import React from 'react'
import { useLocation } from 'react-router-dom';

import {loadStripe} from '@stripe/stripe-js';
import {
    Elements, PaymentElement,
} from '@stripe/react-stripe-js';

import {
    Card,
    Container,
    Row,
    Col,
    CardBody,

} from "reactstrap";
import Header from 'components/Headers/Header'
import SubscriptionForm from 'components/Payments/SubscriptionForm';

// const stripePromise = loadStripe('pk_test_51Jc7T3LrYzlL9Yv87MMJ6RYPDrp3btJth6fbaZJrykBY0ePHxiMIs9jdohnTcovMW75tepSVyTx1qqdHfW5C6G2n00Qa2b7ZuR');
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
const Payment = (props) => {
    const location = useLocation();
    const locationSpecialty = location.state?.specialty || null;
    const locationIsAddon = location.state?.isAddon || props.isAddon || false;
    const locationSelectedPlan = location.state?.selectedPlan || null;
    const locationIsBundle = location.state?.isBundle || props.isBundle || false;
    const locationBundleId = location.state?.bundleId || props.bundleId || null;
    const locationBundleTotalPrice = location.state?.bundleTotalPrice || props.bundleTotalPrice || null;
    const locationBundleName = location.state?.bundleName || props.bundleName || null;
    const locationBundleSpecialties = location.state?.bundleSpecialties || props.bundleSpecialties || null;
    const isStandalone = !props.selectedPlan;

    const options = {
        mode: 'payment',
        amount: 9900, // Default to 1-month plan regular price ($99)
        currency: 'usd',
        payment_method_types: ['card', 'link'],
        setup_future_usage: 'off_session',
        // Fully customizable with appearance API.
        appearance: {/*...*/}
    };


    return (
        <>
            {isStandalone && <Header />}
            <Container className={isStandalone ? "mt--7 mb-7" : "mb-7"} fluid>

                <Row>
                    <div className="col">
                        <Row>
                            {/* <Col lg="3"></Col> */}
                            <Col lg="12" className='mt-3'>

                                <Elements stripe={stripePromise} options={options}>

                                    <SubscriptionForm
                                        selectedPlan={props.selectedPlan || locationSelectedPlan}
                                        overrideSpecialty={locationSpecialty}
                                        isAddon={locationIsAddon}
                                        isBundle={locationIsBundle}
                                        bundleId={locationBundleId}
                                        bundleTotalPrice={locationBundleTotalPrice}
                                        bundleName={locationBundleName}
                                        bundleSpecialties={locationBundleSpecialties}
                                    />
                                </Elements>

                            </Col>
                            {/* <Col lg="3"></Col> */}
                        </Row>
                    </div>
                </Row>

            </Container>
        </>
    )
}

export default Payment